export default __webpack_public_path__ + "static/media/client-06.42d69310.svg";